import { get } from "@/utils/networkCache";
import { request } from "leatherman-js";
import Status from "@/classes/Status";

const appsByBrand = {
  liquidweb: ["wordpress", "woocommerce"],
  nexcess: [
    "magento",
    "bigcommerce",
    "sylius",
    "craftcms",
    "drupal",
    "expressionengine",
    "orocrm",
    "generic",
  ],
};

const appPackages = {
  namespaced: true,
  state: {
    status: new Status(),
    list: [],
  },
  mutations: {
    SET_STATUS(state, payload) {
      state.status.value = payload;
    },
    SET_LIST(state, payload) {
      state.list = payload;
    },
  },
  actions: {
    async getList({ commit }) {
      commit("SET_STATUS", Status.LOADING);
      const appPackages = await get("getAppPackages", request.makeParse, ["getAppPackages"]);
      commit("SET_LIST", appPackages);
      commit("SET_STATUS", Status.LOADED);
      return appPackages;
    },
  },
  getters: {
    getListStatus: (state) => {
      return state.status;
    },
    getPackages: (state) => {
      return state.list;
    },
    getPackagesByApp: (state, getters, rootState) => (app) => {
      if (!app) {
        return [];
      }
      // get only appPackages that are compatible with the selected app
      // sort by price
      return state.list
        .filter((pack) => {
          const appSupportsBrand = appsByBrand[pack.brand].includes(app.type);
          return (
            pack.app?.id === app.id &&
            !pack.freeTrial &&
            appSupportsBrand &&
            !rootState.checkout.storeBuilderUiOverrideIds.includes(`${pack.id}`)
          );
        })
        .sort((a, b) => {
          return a.monthlyFee - b.monthlyFee;
        });
    },
    getAppPackage: (state) => (packageId, appId) => {
      return state.list.find(({ id, app }) => {
        // if app is present, check its id too
        if (app) {
          return id === packageId && app.id === appId;
        }
        // otherwise just check the package id (not all appPackages have an app)
        return id === packageId;
      });
    },
  },
};

export default appPackages;
